import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext.jsx';
import { FaShieldAlt, FaExclamationTriangle } from 'react-icons/fa';

const AdminRHProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, user } = useAuth();

  // Afficher un loader pendant la vérification de l'authentification
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification des permissions d'administration RH...</p>
        </div>
      </div>
    );
  }

  // Rediriger vers login si non authentifié
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  // Autoriser tous les utilisateurs authentifiés (suppression des restrictions de rôle)
  // Les restrictions seront gérées au niveau des API et des composants individuels

  // Afficher le contenu AdminRH si l'utilisateur est authentifié et a les bonnes permissions
  return children;
};

export default AdminRHProtectedRoute;




